export const GET_MERCHANT_BASIC_INFO = `query GetMerchantBasicInfo {
    merchant{
        id
        defaultPaymentMethod {
            id
        }
        features
        hidePlans
        logo
        logoBgColor
        metadata
        name
        onboarding {
            metadata
            tiktokSellerPortalPermissionsGranted
        }
        settingsObj
        tiktokBusinessAuthUrl
        tiktokPlan: plan(feature: TIKTOK_SHOP){
            id
        }

        youtubePlan: plan(feature: YOUTUBE_SHOPPING){
            id
        }
    }
}`;
